import { Component, PropsWithChildren } from "react"

import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Container from "@mui/material/Container"
import { useTranslation } from "react-i18next"

type ErrorBoundaryState = {
  hasError: boolean
}

const ErrorFallback = () => {
  const { t } = useTranslation()

  return (
    <Container sx={{ py: 4 }}>
      <Alert severity="error">
        <AlertTitle>{t("errorBoundary.title")}</AlertTitle>
        <Box sx={{ mb: 2 }}>{t("errorBoundary.message")}</Box>
        <Button variant="contained" onClick={() => window.location.reload()}>
          {t("errorBoundary.reloadButton")}
        </Button>
      </Alert>
    </Container>
  )
}

class ErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />
    }

    return this.props.children
  }
}

export default ErrorBoundary
